import styled from 'styled-components';

export const StyledPage = styled.div``;
